import { commonRequest } from "../../../services/ApiCall";
import { Helpers } from "../../../services/Helpers";

export const EventServices = {

    allEvents : async (data) =>{
        console.log('Received parameters data:',data);

        const queryParams = new URLSearchParams();

        // Basic pagination and sorting parameters
        queryParams.append('page', data.page + 1);
        queryParams.append('limit', data.limit);

        // Search parameters
        queryParams.append('searchKey', data.filters.searchKey || '');
        

        // Sorting parameters
        if (data.filters.sortBy) {
            queryParams.append('sortBy', data.filters.sortBy);            
            queryParams.append('sortType', data.filters.sortType || 'desc');
        }

        // Additional multi-column filters
        if (data.filters.filterOptions) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                    
                    if (filter.operator === 'between') {
                        queryParams.append(`filters[${index}][endValue]`, filter.endValue);                        
                    }
                }
            });
        }
        console.log("queryParams",queryParams.toString());
        return await commonRequest("get",  `${Helpers.URL()}/api/admin/lyns-events/list?${queryParams.toString()}`,{}, Helpers.token());
    },

    addEvent : async (data) =>{
        return await commonRequest("POST", `${Helpers.URL()}/api/admin/lyns-events/create`,data, Helpers.token());
    },

    updateEvent : async (data,id) =>{
        return await commonRequest("PUT",  `${Helpers.URL()}/api/admin/lyns-events/update/${id}`, data, Helpers.token());
    },
    deleteEvent : async (id) =>{
        return await commonRequest("DELETE",  `${Helpers.URL()}/api/admin/lyns-events/delete/${id}`, {}, Helpers.token());
    },
    restoreEvent : async (id) =>{
        return await commonRequest("PUT",  `${Helpers.URL()}/api/admin/lyns-events/restore/${id}`, {}, Helpers.token());
    },

    fetchBrandData : async (id) =>{
        return await commonRequest("get",  `${Helpers.URL()}/api/v2/admin/service-master/getServiceDetails/${id}`,{}, Helpers.token());
    },
    changeBrandStatus : async (id) =>{
        return await commonRequest("get",  `${Helpers.URL()}/api/v2/admin/service-master/changeStatus/${id}`, {}, Helpers.token());
    },
    subCategoryList : async (data)=>{
        return await commonRequest("get",  `${Helpers.URL()}/api/admin/service-category/getSubCategories/${data.categoryId}`,{}, Helpers.token());
    },
    categoryList : async (data)=>{
        return await commonRequest("get",  `${Helpers.URL()}/api/admin/service-category/getCategories`,{}, Helpers.token());
    },
    serviceList: async (data)=>{
        // return await commonRequest("get",  `${Helpers.URL()}/api/v2/admin/service-master/getServicesBySubcategory/${data.subCategoryId}`,{}, Helpers.token());

        return await commonRequest("get",  `${Helpers.URL()}/api/admin/service-master/getServicesBySubcategory/${data.subCategoryId}`,{}, Helpers.token());
    },
}
